// @flow
import PlanogramItem, { type RawDataItem } from './planogram-item';


export function createPlanogramItem(props: RawDataItem): PlanogramItem {
  return new PlanogramItem(props);
}
